import { useEffect, useState } from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

import RushHourModal from "shared/components/RushHourModal";
import localStorage from "shared/util/localStorage";
import isRushHour from "shared/util/isRushHour";
import { ROUTES } from "routers/shared/util/consts";

const LOCAL_STORAGE_KEY = "rush_hour_modal_last_seen";

export const NO_RUSH_HOUR_ROUTES = [
	...ROUTES.Offboarding,
	...ROUTES.Onboarding,
	...ROUTES.PhoneWall,
	...ROUTES.StandaloneConversation,
	...ROUTES.Upgrade,
];

export function hasntShownRecently() {
	const lastSeen = localStorage.getItem(LOCAL_STORAGE_KEY);

	if (!lastSeen) {
		return true;
	}

	const lastSeenDate = parseInt(lastSeen, 10);
	const TWO_WEEKS = 2 * 7 * 24 * 60 * 60 * 1000;
	return Date.now() - lastSeenDate > TWO_WEEKS;
}

export function recordShown(shownTime = Date.now()) {
	localStorage.setItem(LOCAL_STORAGE_KEY, shownTime);
}

export function shouldShowRushHourModal(location, user, isVisible) {
	const isLoggedIn = !!user.id;
	const hasPhotos = !!user.hasPhotos;
	const hasBoostTokens = !!user.boostTokenCount;
	const isIncognito = !!user.isIncognito;
	const isBoostAvailable = isLoggedIn && !isIncognito && (hasPhotos || hasBoostTokens);
	const isAllowedRoute = !NO_RUSH_HOUR_ROUTES.includes(location.pathname);
	return (
		!isVisible &&
		isBoostAvailable &&
		isAllowedRoute &&
		isRushHour() &&
		hasntShownRecently()
	);
}

export const RUSH_HOUR_QUERY = gql`
	query checkRushHourEligible($userid: String!) {
		user(id: $userid) {
			id
			hasPhotos
			boostTokenCount
			isIncognito
		}
	}
`;

/**
 * Shows Rush Hour modal at the appropriate time & place.
 * @param {object} location - current browser location.
 * @param {object} userid - userid to check eligibility.
 */
function useRushHourModal(location, userid) {
	const [isVisible, setIsVisible] = useState(false);
	const { data } = useQuery(RUSH_HOUR_QUERY, {
		variables: {
			userid,
		},
	});
	const user = data && data.user;
	const shouldShow = user && shouldShowRushHourModal(location, user, isVisible);

	useEffect(() => {
		if (!shouldShow) {
			return;
		}

		setIsVisible(true);
		recordShown();
		RushHourModal.open({ userid: user.id });
	}, [shouldShow, user]);
}

export default useRushHourModal;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useRushHourModal.js